// 交易對手 - 繁體中文
export default {
  loading: { text: "拼命加載中" },
  filters: {
    tag: "標籤",
    currency: "幣種",
    direction: "方向",
    selectTag: "請選擇標籤",
    selectCurrency: "請選擇幣種",
    selectDirection: "請選擇方向",
    more: "更多",
    amountRange: "金額區間",
    minAmount: "最小金額",
    maxAmount: "最大金額",
  },
  table: {
    totalPrefix: "共計",
    totalSuffix: "條數據",
    download: "下載",
    empty: "暫無數據",
    counterparty: "交易對手",
    totalValue: "交易金額",
    totalCount: "交易筆數",
    actions: "操作",
  },
  directionOptions: {
    ALL: "雙向",
    INFLOW: "轉入",
    OUTFLOW: "轉出",
  },
};
